import { buildUrl } from './links';
export const getPropsFromItems = (items)=>items.map(({ linkEntry, linkUrl, list, openInNewTab, text, trackingOption })=>{
        const href = (linkUrl || linkEntry && buildUrl(linkEntry)) ?? '#';
        let tracking;
        try {
            tracking = trackingOption?.length === 1 ? {
                eventName: trackingOption[0].eventName,
                customProps: trackingOption[0].customProps ? JSON.parse(trackingOption[0].customProps) : undefined
            } : undefined;
        } catch (_e) {
        //
        }
        return {
            text: text ?? '',
            href,
            shouldOpenInNewTab: openInNewTab,
            tracking,
            items: list && getPropsFromItems(list)
        };
    });

//# sourceMappingURL=getNavigationProps.js.map